module.exports = __webpack_public_path__ + "img/result_celling.0473d213.jpg";